import { observable, action, toJS, computed, makeObservable, runInAction } from 'mobx'
import decode from 'jwt-decode'
import api from '../service/api'
import NotificationStore from "./notification.store"
import React from 'react'
import dayjs from 'dayjs'
// import UserStore from "./user.store";
const notification = NotificationStore



class AuthStore {

    auth // Logged In Json Info
    erp_session_state = 'loggedout'

    constructor () {
        this.auth = ( this.getToken === null ) ? false : !( this.isTokenExpired( this.getToken ) )
        this.api = api
        makeObservable( this, {
            auth: observable,
            getAuth: computed,
            erp_session_state: observable,
            setAuth: action,
            doAuth: action,
            setToken: action,
            getToken: computed,
            doLogout: action,
            isTokenExpired: action,
            doImpersonationAuthViaERPAuthToken: action,
            doImpersonationAuthViaLMSAuthToken: action,
            doAuthViaERPAuthToken: action,
            getErpSessionState: computed,
            setERPSessionState: action
        } )
    }

    // get compute_func()

    get getAuth () {
        //console.log(this.auth)
        this.auth = ( this.getToken === null ) ? false : !( this.isTokenExpired( this.getToken ) )
        return toJS( this.auth )
    }

    //signInERP
    async doAuth ( payload ) {
        try {
            const res = await this.api.signIn( payload )
            if ( res["data"]["success"] === true ) {
                this.setToken( res["data"]["token"] )
                notification.setNotification( true, "Login Success!" )
            } else
                notification.setNotification( true, "Invalid Login Credentials!" )
            return res["data"]
        } catch ( err ) {
            console.log( err )
            notification.setNotification( true, err?.response?.data?.message || "Failed to login! please try again." )
            return false
        }
    }

    async doAuthViaERPAuthToken ( token ) {
        try {
            const { data } = await this.api.lmsLoginWithToken( { token } )
            if ( data["status"] === true ) {
                this.setToken( data["token"] )
                localStorage.setItem( 'user_role', data["user_role"] )
                notification.setNotification( true, "Login success!" )
                this.setERPSessionState( 'active' )
                return data["status"]
            } else if ( data["status"] === false ) {
                notification.setNotification( true, data["message"] )
                return data["status"]
            } else {
                notification.setNotification( true, data["message"] )
                return data["status"]
            }
        } catch ( err ) {
            console.log( err )
            if ( err.response && err.response.data && err.response.data.message )
                notification.setNotification( true, err.response.data.message )
            else
                notification.setNotification( true, "Something went wrong. Try again!" )
            return false
        }
    }

    async doImpersonationAuthViaERPAuthToken ( token ) {
        try {
            const { data } = await this.api.lmsImpersonationWithToken( { token } )
            if ( data["status"] === true ) {
                sessionStorage.setItem( 'impersonation_id_token', data.data.token )
                sessionStorage.setItem( 'is_impersonation', true )
                sessionStorage.setItem( 'impersonator_details', JSON.stringify( data.data.impersonator_details ) )
                sessionStorage.setItem( 'impersonation_session_ends_at', data.data.session_end )
                notification.setNotification( true, "Login success!" )
                this.setERPSessionState( 'active' )
                return data["status"]
            } else if ( data["status"] === false ) {
                notification.setNotification( true, data["message"] )
                return data["status"]
            } else {
                notification.setNotification( true, data["message"] )
                return data["status"]
            }
        } catch ( err ) {
            console.log( err )
            if ( err.response && err.response.data && err.response.data.message )
                notification.setNotification( true, err.response.data.message )
            else
                notification.setNotification( true, "Something went wrong. Try again!" )
            return false
        }
    }

    async doImpersonationAuthViaLMSAuthToken ( token, session_end ) {
        try {
            if ( token ) {
                sessionStorage.setItem( 'impersonation_id_token', token )
                sessionStorage.setItem( 'is_impersonation', true )
                sessionStorage.setItem( 'impersonation_session_ends_at', session_end || dayjs().add( 30, 'minutes' ) )
                notification.setNotification( true, "Login success!" )
                this.setERPSessionState( 'active' )
                return true
            } else {
                notification.setNotification( true, "Failed to initiate impersonation! Please try again!" )
                this.setERPSessionState( 'ended' )
                return false
            }
        } catch ( err ) {
            console.log( err )
            notification.setNotification( true, "Something went wrong. Try again!" )
            return false
        }
    }

    async doAuthViaERP ( payload, showSuccessToast = true ) {

        try {
            const res = await this.api.signInERP( payload )

            //this.auth = true;
            if ( res["data"]["status"] === true ) {
                // this.setToken( res["data"]["token"] )
                // if ( showSuccessToast )
                //     notification.setNotification( true, res["data"]["message"] )
                this.setERPSessionState( 'active' )
                return res["data"]
            } else if ( res["data"]["status"] === false ) {
                notification.setNotification( true, res["data"]["message"] )
                return res["data"]
            } else {
                notification.setNotification( true, res["data"]["message"] )
                return res["data"]
            }
        } catch ( err ) {
            console.log( err )
            if ( !window.navigator.onLine )
                return notification.setNotification( true, "Please connect to internet!" )
            if ( err.response )
                notification.setNotification( true, err?.response?.data?.message || "Something went wrong. Try again!" )
            else if ( err.message === "Network Error" && !window.navigator.onLine )
                notification.setNotification( true, "Check your internet connection!" )
            else if ( err.message === "Network Error" && window.navigator.onLine )
                notification.setNotification( true, "Server seems to be facing some trouble! please try again." )
            else
                notification.setNotification( true, "Server seems to be facing some problems! Please try again later." )
            return false
        }
    }

    async doStudyMaterialLogin ( payload ) {
        try {
            const res = await this.api.signInStudyMaterial( payload )
            localStorage.setItem( "aliveMaterialAPIAK", res.data.token )
            return true
        } catch ( e ) {
            console.log( "ERR1", e )
            notification.setNotification( true, ( e.response && e.response.data ) ? e.response.data : "Something went wrong! try again later" )
            return false
        }
    }
    async doExamLogin ( payload ) {
        try {
            const res = await this.api.signInExam( payload )
            localStorage.setItem( "aliveAPIAK", res.data.token )
            return true
        } catch ( e ) {
            console.log( "ERR2", e )
            notification.setNotification( true, ( e.response && e.response.data && e.response.data.message ) ? e.response.data.message : "Something went wrong! try again later" )
            return false
        }
    }

    setAuth ( auth ) {
        this.auth = auth
    }

    setToken ( token ) {
        localStorage.setItem( 'id_token', token )
    }

    setERPSessionState ( state ) {
        runInAction( () => { this.erp_session_state = state } )
    }

    get getToken () {
        return localStorage.getItem( 'id_token' )
    }

    async doLogout () {
        try {
            await api.logout()
        } catch ( err ) {
            console.log( err )
        } finally {
            localStorage.removeItem( 'id_token' )
            localStorage.removeItem( 'poll_session' )
            localStorage.removeItem( 'active_session' )
            runInAction( () => {
                this.auth = false
                this.erp_session_state = 'loggedout'
            } )
        }
        return true
    }

    get getErpSessionState () {
        return this.erp_session_state
    }

    isTokenExpired ( token ) {
        try {
            const decoded = decode( token )
            if ( decoded.exp < Date.now() / 1000 ) { // Checking if token is expired. N
                this.setAuth( false )
                return true
            }
            else {
                this.setAuth( true )
                return false
            }
            //return false;
        }
        catch ( err ) {
            return false
        }
    }
}

// decorate(AuthStore, {
//     auth:observable,
//     getAuth:computed,
//     setAuth:action,
//     doAuth:action,
//     setToken:action,
//     getToken:computed,
//     doLogout:action,
//     isTokenExpired:action
// })

const AuthStoreInstance = new AuthStore()

export default AuthStoreInstance

const AuthStoreContext = React.createContext()

export const AuthStoreProvider = ( { children, store } ) => {
    return (
        <AuthStoreContext.Provider value={store}>{children}</AuthStoreContext.Provider>
    )
}

/* Hook to use store in any functional component */
export const useAuthStore = () => React.useContext( AuthStoreContext )